export default "__VITE_ASSET__BBa_Da$l__"